module.exports = __webpack_public_path__ + "img/presence-ebook-cover.bf81f7d9.png";